module.exports = __webpack_public_path__ + "5bf87bd5dd81bb399a4802a7ee4a1eb7.jpg";